import { ICardElementWithChildren } from "backend/model/model";
import PerspectiveCardList from "design/components/grids/PerspectiveCardList";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { ElementOverviewStackedCard } from "../cards/ElementOverviewStackedCard";
import { IChartSelectEvent } from "../charts/types";

const usePerformanceSummaryBarsStyles = makeThemedStyles(
  "PerformanceSummaryBars",
  (theme) => ({
    root: {
      width: "30.4em",
      minHeight: "37.1em",
      fontSize: "10px",
      borderRadius: ".8em",
      border: "1px solid rgba(247, 247, 247, 1)",
    },
    divider: {
      height: "20px",
    },
  })
);

export const PerformanceSummaryBars = React.memo(
  (
    props: React.PropsWithChildren<{
      elements: ICardElementWithChildren[];
      periodName: string;
      title: string;
      typenames: string[];
      onSelect?: (value: IChartSelectEvent) => void;
    }>
  ) => {
    const styles = usePerformanceSummaryBarsStyles();
    const ctx = useAppContext();
    return (
      <PerspectiveCardList>
        {props.elements
          .sort((a, b) => a.symbol.localeCompare(b.symbol))
          .map((el) => {
            return (
              <ElementOverviewStackedCard
                element={el}
                translatedName={getTranslatedAttribute(
                  el,
                  "Name",
                  ctx.language
                )}
                title={props.title}
                periodName={el?.periodname || ""}
                typenames={props.typenames}
                onSelect={props.onSelect}
              />
            );
          })}
      </PerspectiveCardList>
    );
  }
);
